import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { getJson } from '../../helpers/RequestsHelper';
import BlockSetupInput from './Inputs/BlockSetupInput';
import AvailableFields from './Inputs/AvailableFields';
import { getName } from './Inputs/DragDropHelpers';

import { allActions, updateName, populateTypes } from '../../helpers/applications'

class BlockSetupCustomSteps extends Component {

    state = {
        error: false,
        loading: true,
        properties: {},
        fields: undefined,
        updateFields: true
    }

    constructor() {
        super()
        this.loadJson = this.loadJson.bind(this)
        this.onChange = this.onChange.bind(this)
        this.addNewField = this.addNewField.bind(this)
        this.removeField = this.removeField.bind(this)
    }
    componentDidMount() {
        if (this.props.path) {
            this.loadJson();
        }
        this.updateFields();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.path) {
            if (this.props.path !== prevProps.path) {
                this.loadJson()
            }
        }

        this.updateFields();
    }

    updateFields() {
        if (this.state.updateFields) {
            let steps = this.state.steps;
            let type = this.state.type;
            if (type) {
                this.addDefaultFields(type, steps);

                this.sortPopular(steps, type.id);
                this.setState({ steps, type, updateFields: false });
            }
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.fields != state.fields && "string" === typeof props.fields ||
            Array.isArray(props.fields) && (state.fields && props.fields.length !== state.fields.length || !state.fields)
            //TODO: Compare the values of 2 arrays
        ) {
            let steps = []
            let type
            if (Array.isArray(props.fields)) {
                type = { fields: props.fields }
            } else {
                const actions = allActions[props.block.application]
                type = actions.types[props.fields]

                type = JSON.parse(JSON.stringify(type));
                for (let j = 0; j < type.fields.length; j++) {
                    const field = type.fields[j];
                    updateName(field);
                    field.typeId = type.id;
                }

                populateTypes(type, type, actions.types, actions.popularFields, "", "")
            }

            state.error = false
            state.steps = steps
            state.loading = false
            state.type = type
            state.fields = props.fields
            state.updateFields = true
            // } else {
            //     if (!props.path) {
            //         state.loading = false
            //     }
        }

        if (state.value !== props.value) {
            state.properties = props.value
        }

        return state
    }

    sortPopular = (steps, typeId) => {
        const popularFields = allActions[this.props.block.application].popularFields
        if (popularFields && popularFields[typeId]) {
            const popular = popularFields[typeId];
            steps.sort((a, b) => (popular.indexOf(a.id) > popular.indexOf(b.id)) ? 1 : -1)
        }
    }

    addDefaultFields = (type, steps) => {
        type.fields.map((field) => {
            if (field.dataType === "$ref" && field.subtype) {
                this.addDefaultFields(field.subtype, steps)
            }
            const actions = allActions[this.props.block.application]
            if (actions.popularFields &&
                actions.popularFields[type.id] &&
                actions.popularFields[type.id].includes(field.id)) {
                field.popular = true
            }
            const block = this.props.block
            if (field.popular
                || field.required
                || (block.params && block.params.fields && block.params.fields[field.id])
            ) {
                this.addField(field, steps);
            }
        });
    }

    addNewField(field) {
        let steps = this.state.steps
        //Uncomment if we want to remove instead of reorder
        // let type = this.state.type
        this.addField(field, steps)
        // const index = type.fields.indexOf(field);
        // type.fields.splice(index, 1);
        //this.setState(({ steps, type }))
        this.setState(({ steps }))
    }

    removeField(stepId) {
        let steps = this.state.steps
        let type = this.state.type
        const index = steps.findIndex(step => step.id == stepId);
        const step = this.state.steps[index]
        //type.fields.push(step.field)
        steps.splice(index, 1);
        //type.fields.sort((a, b) => (a.name > b.name) ? 1 : -1)

        //remove from properties
        let properties = this.state.properties
        delete properties[stepId]

        this.setState(({ steps, type, properties }))

        this.props.onChange(this.props.stepId, properties)
    }

    addField(field, steps) {
        //if (field.id !== "id")
        {
            let step;
            const selectors = allActions[this.props.block.application].selectors
            if (selectors) {
                step = selectors.find(a => a.id === field.id)
            }
            if (!step) {
                step = {}
                let stepType;
                switch (field.dataType) {
                    case "bool":
                        stepType = "toggle";
                        break;
                    case "long":
                        stepType = "inputlong";
                        break;
                    case "number":
                        stepType = "inputnumber";
                        break;
                    case "date":
                        stepType = "inputdate";
                        break;
                    case "datetime":
                        stepType = "inputdatetime";
                        break;
                    case "array":
                        stepType = "array";
                        break;
                    case "fields":
                        stepType = "fields";
                        break;
                    case "field":
                        stepType = "field";
                        break;
                    case "daterange":
                        stepType = "daterange";
                        break;
                    case "html":
                        stepType = "inputhtml";
                        break;
                    case "text":
                        if (field.enum) {
                            stepType = "select"
                            step.items = []
                            for (let i = 0; i < field.enum.length; i++) {
                                const id = field.enum[i];
                                const name = field.enumDescriptions ? field.enumDescriptions[i] : id;
                                step.items.push({ id, name })
                            }
                        } else {
                            stepType = "input";
                        }
                        break;
                    default:
                        stepType = "input";
                        break;
                }

                step.type = stepType
            }

            step.id = field.id
            step.label = step.label ? step.label : getName(field)
            step.description = step.description !== undefined ? step.description : field.description ? field.description : field.label

            // if (step.description && step.description.startsWith(step.label)) {
            //     if (step.description == step.label) {
            //         delete step.description
            //     } else {
            //         step.description.substr(step.label.length)
            //     }
            // }
            step.field = field

            if (field.required) {
                step.required = field.required
            }
            if (field.default) {
                step.default = field.default
            }
            if (field.popular) {
                step.popular = field.popular
            }
            if (field.import) {
                for (let i = 0; i < this.props.inputTypes.length; i++) {
                    const type = this.props.inputTypes[i];
                    var exportedField = type.fields.find(a => a.export === field.import)
                    if (exportedField) {
                        step.default = `{{${exportedField.id}:${exportedField.typeId}:${exportedField.dataType}}}`
                        var updateDefault = true
                        break
                    }
                }
            }


            var index = steps.findIndex(a => a.id == step.id)
            if (index >= 0) {
                steps.splice(index, 1)
            }
            steps.push(step)
            if (updateDefault) {
                this.onChange(step.id, step.default)
            }
        }
    }

    async loadJson() {
        try {
            const steps = await getJson(process.env.REACT_APP_SERVER_BASE_URL + this.props.path)
            if (steps.error) {
                this.setState(({ error: true, errorMessage: steps.error.message, loading: false, updateFields: true }))
            } else {
                this.setState(({ error: false, steps: steps, loading: false }))
            }
        } catch {
            this.setState(({ error: true, loading: false }))
        }
    }

    onChange(stepId, property) {
        let properties = this.state.properties

        //TODO: [Data types] Add all types
        const currentStep = this.state.steps.find(a => a.id === stepId)
        if (currentStep.type === "toggle") {
            property = { value: property }
            property.type = "bool"
        }

        properties[stepId] = property
        this.props.onChange(this.props.stepId, properties)
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) return <div className="spinner-border" role="status">
            <span className="sr-only">{t("loading")}</span>
        </div>

        const allIncluded = !this.state.type || this.state.type.fields.length === this.state.steps.length //If all are added we don't display add

        let steps = []
        if (!this.state.error) {
            for (let i = 0; i < this.state.steps.length; i++) {
                const step = this.state.steps[i];
                const key = this.props.block.id + "_" + i
                if (allIncluded) {
                    steps.push(<BlockSetupInput key={key} step={step} block={this.props.block} accountId={this.props.accountId} onChange={this.onChange} value={this.props.value ? (this.props.value[step.id] ? this.props.value[step.id] : step.default) : step.default} inputTypes={this.props.inputTypes} />)
                }
                else {
                    steps.push(
                        <table width="100%" key={key} ><tbody><tr>
                            {(this.state.type && this.state.type.fields.length > 0) ?
                                <td width="30" style={{ verticalAlign: "top" }}>
                                    {step.required ? "" : <button
                                        className="icon-button field-add-button"
                                        title={t("tip_field_remove")}
                                        style={{ "top": "0px" }}
                                        onClick={() => this.removeField(step.id)}
                                    ><i className="fas fa-minus"></i></button>}
                                </td>
                                : ""}
                            <td>
                                <BlockSetupInput step={step} block={this.props.block} accountId={this.props.accountId} onChange={this.onChange} value={this.props.value ? (this.props.value[step.id] ? this.props.value[step.id] : step.default) : step.default} inputTypes={this.props.inputTypes} />
                            </td></tr></tbody></table>)
                }
            }
        }
        return <div>{this.state.error ?
            <small id="errorMessage" className="text-danger">
                {this.state.errorMessage ? this.state.errorMessage : t("title_error")}
            </small>
            :
            steps}
            <br />
            {this.state.type && this.state.type.fields.length > 0 && !allIncluded
                ? <div className="dropdown">
                    <button
                        key="addFieldsButton"
                        id="addFields"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className="icon-button field-add-button"
                        title={t("tip_field_add")}
                        style={{ "top": "0px" }}
                    ><i className="fas fa-plus"></i></button>&nbsp;&nbsp;{t("tip_field_add")}
                    <div className="dropdown-menu field-selector" aria-labelledby="addFields" key="addFields" style={{ padding: "4px" }}>
                        <AvailableFields types={[this.state.type]} onFieldClick={this.addNewField} />
                    </div>
                </div>
                : ""}
        </div>
    }
}

export default withTranslation()(BlockSetupCustomSteps)